<template>
  <div>
    <div class="content">
      <div class="header-image">
        <img src="@/assets/splash-logo.png" height="102" width="100" alt="Logo">
      </div>
      <div class="header-text">
        <h3>SMART STEWARDS</h3>
        <p class="">Learn To Make, Manage & Multiply Money</p>
      </div>
      <p class="secondary-text text-left">Everyone makes money mistakes.
        <br>We sometimes invest wrongly, indulge foolishly and are indebted hopelessly,
        but here we learn to become better Managers and Stewards a journey towards
        financial liberation.</p>

      <div class="links-card">
        <div class="links-card-section" @click="smartAcademy">
          <div class="first-col">
            <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Smart Stewards Academy</p>
            <p class="sub-text">Visit our academy to get content to help you boost your
            financial literacy</p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
          </div>
        </div>

        <div class="links-card-section" @click="smartAcademy2">
          <div class="first-col">
            <img src="@/assets/academy.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Smart Stewards 4-level Academy Plan</p>
            <p class="sub-text">Visit our academy to get content to help you boost your
            financial literacy</p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
          </div>
        </div>

        <div class="links-card-section" @click="openLiteracy">
          <div class="first-col">
            <img src="@/assets/literacy.png" height="30" width="30" alt="Logo">
          </div>
          <div class="second-col">
            <p class="cabin-family bold">Financial Literacy Assesment</p>
            <p class="sub-text">Visit our academy to get content to help check your
            financial literacy</p>
          </div>
          <div class="third-col">
            <img src="@/assets/right-chevron.png" height="11" width="6" alt="Logo">
          </div>
        </div>
      </div>
      <div class="get-started-btn">
        <button class="btn primary-btn btn-block" @click="getStarted">GET STARTED</button>
      </div>
    </div>
    <literacy-component v-if="Literacy" @close="closeLiteracy"></literacy-component>
  </div>
</template>

<script>
import LiteracyComponent from '../views/Literacy.vue';

export default {
  components: {
    LiteracyComponent,
  },
  data() {
    return {
      Literacy: false,
      showLiteracy: true,
    };
  },
  mounted() {
    this.checkRiskAppetite();
  },
  methods: {
    getStarted() {
      localStorage.setItem('getStarted', true);
      this.$router.push('/');
    },
    smartAcademy() {
      window.open('https://smart-stewards.thinkific.com/', '_blank');
    },
    smartAcademy2() {
      window.open('https://academy.smartstewards.com', '_blank');
    },
    openLiteracy() {
      this.Literacy = true;
      // this.$router.push('literacy');
    },
    closeLiteracy() {
      this.Literacy = false;
      console.log('back here');
      this.checkRiskAppetite();
    },
    checkRiskAppetite() {
      const riskAppetite = localStorage.getItem('risk_appetite');
      if (riskAppetite) {
        this.getStarted();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .content{
    margin-top: 1rem;
    position: absolute;
    top: 0;
    text-align: center;
  }
  .header-image{
    margin-bottom: 3rem;
  }
  .header-text{
    margin-bottom: 2rem;
  }
  .secondary-text {
    color: #6B6B6B;
    margin-bottom: 1rem;
  }
  .get-started-btn{
    margin-top: 2rem;
  }
</style>
